import { api } from "shared/redux/api"
import { useMutationWithCallbacks } from "../../hooks/useMutationWithCallbacks"
import { objectToQueryString } from "shared/utils/common"

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetVersion: build.query({
      query: () => {
        return {
          url: "/actuator/info",
        }
      },
      transformResponse: (response) => response.build,
    }),
    getTeachers: build.query({
      query: (arg) => {
        return {
          url: `/private/teacher/v1${
            arg ? `?${objectToQueryString(arg)}` : ""
          }`,
        }
      },
    }),

    createTemplate: build.mutation({
      query: (arg) => {
        return {
          url: `/private/notification/v1/template`,
          method: "POST",
          body: arg,
        }
      },
    }),
    updateTemplate: build.mutation({
      query: (arg) => {
        return {
          url: `/private/notification/v1/template`,
          method: "POST",
          body: arg,
        }
      },
    }),
    getTemplates: build.query({
      query: (arg) => {
        const { key, page, size, sort } = arg
        return {
          url: `/private/notification/v1/template?key=${key}&page=${page}&size=${size}&sort=${sort}`,
        }
      },
    }),
    deleteTemplate: build.mutation({
      query: (arg) => {
        const { templateId } = arg
        return {
          url: `/private/notification/v1/template/${templateId}`,
          method: "DELETE",
        }
      },
    }),
    getAdmins: build.query({
      query: (arg) => {
        const { page, size, sort } = arg
        return {
          url: `/private/admin/v1?page=${page}&size=${size}&sort=${sort}`,
        }
      },
    }),
    putUnLockPin: build.mutation({
      query: (arg) => {
        const { email } = arg
        return {
          url: `/private/admin/v1/unlock-pin/${email}`,
          method: "PUT",
          body: arg,
        }
      },
    }),
    getCenterList: build.query({
      query: (arg) => {
        return {
          url: `/private/center/v1${arg ? `?${objectToQueryString(arg)}` : ""}`,
        }
      },
    }),
    getLXOs: build.query({
      query: (arg) => {
        return {
          url: `/private/lxo/v1${arg ? `?${objectToQueryString(arg)}` : ""}`,
        }
      },
      transformResponse: (response) => response?.data?.data,
    }),
    getDetailLXO: build.query({
      query: (arg) => {
        const { id } = arg
        return {
          url: `/private/lxo/v1/${id}`,
        }
      },
      transformResponse: (response) => response?.data,
    }),
    updateLXO: build.mutation({
      query: (arg) => {
        const { id, ...res } = arg
        return {
          url: `/private/lxo/v1/${id}`,
          method: "PUT",
          body: res,
        }
      },
    }),
    changePasswordLXO: build.mutation({
      query: (arg) => {
        const { id, ...res } = arg
        return {
          url: `/private/lxo/v1/change-password/${id}`,
          method: "PUT",
          body: res,
        }
      },
    }),
    SyncHub: build.mutation({
      query: (arg) => {
        const { id, ...res } = arg
        return {
          url: `/private/lxo/v1/sync-hub/${id}`,
          method: "PUT",
          body: res,
        }
      },
    }),
  }),
  overrideExisting: false,
})

export const {
  useGetVersionQuery,
  useGetTeachersQuery,
  useLazyGetTeachersQuery,
  useCreateTemplateMutation,
  useLazyGetTemplatesQuery,
  useDeleteTemplateMutation,
  useUpdateTemplateMutation,
  useLazyGetAdminsQuery,
  usePutUnLockPinMutation,
  useGetCenterListQuery,
  useLazyGetCenterListQuery,
  useLazyGetLXOsQuery,
  useGetDetailLXOQuery,
  useUpdateLXOMutation,
  useChangePasswordLXOMutation,
  useSyncHubMutation,
} = injectedRtkApi

export const useAdminAPIs = {
  usePutUnLockPinWithCallbacks: useMutationWithCallbacks(
    usePutUnLockPinMutation
  ),
}
